import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import styleUtils from '../../styles/styleUtils';
import { fontSizes, sizes, } from './constants';
import { icons } from './icons';
const defaultProps = {
    size: sizes.small,
};
const Icon = ({ size = defaultProps.size, type, }) => {
    const svgStyles = useMemo(() => (css `
        font-size: ${styleUtils.rem(fontSizes[size])};
      `), [
        size,
    ]);
    return (_jsx("svg", Object.assign({ css: svgStyles, fill: "currentColor", height: "1em", viewBox: "0 0 24 24", width: "1em" }, { children: icons[type] })));
};
export { Icon };
